import React from 'react'
import PageSection from '../../../../../features/components/PageSection'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import classnames from 'classnames'

import { formatNumberToShort } from '../../../helpers'

import { socialReturnOnInvestmentReportSelector } from '../../../../../modules/selectors/socialReturnOnInvestment'
import { selectedPartnershipCurrency } from '../../../../../modules/selectors/partnerships'

import useStyles from './styles'

const TotalInfo = () => {
  const { t } = useTranslation()
  const classes = useStyles()

  const { totalImpact, totalInvestment, stakeholderImpact } = useSelector(socialReturnOnInvestmentReportSelector)
  const { currency_symbol: currencySymbol } = useSelector(selectedPartnershipCurrency)

  return (
    <div className={classes.totalInfo}>
      <PageSection className={classes.infoBlock}>
        <h3>{t('Total Beneficiaries')}</h3>
        <div className={classes.infoBlockContent}>
          {stakeholderImpact?.Players && (
            <div>
              <div className={classes.totalNumber}>
                {formatNumberToShort(stakeholderImpact?.Players?.stakeholderCount)}
              </div>
              <span className={classes.totalNumberDescription}>{t('Players')}</span>
            </div>
          )}
          {stakeholderImpact?.Attendees && (
            <div>
              <div className={classes.totalNumber}>
                {formatNumberToShort(stakeholderImpact?.Attendees?.stakeholderCount)}
              </div>
              <span className={classes.totalNumberDescription}>{t('Attendees')}</span>
            </div>
          )}
          {stakeholderImpact?.Viewers && (
            <div>
              <div className={classes.totalNumber}>
                {formatNumberToShort(stakeholderImpact?.Viewers?.stakeholderCount)}
              </div>
              <span className={classes.totalNumberDescription}>{t('Fans')}</span>
            </div>
          )}
        </div>
      </PageSection>

      <PageSection className={classes.infoBlock}>
        <h3>{t('Social Value and Investment')}</h3>
        <div className={classes.infoBlockContent}>
          <div>
            <div className={classnames(classes.totalNumber, classes.totalSocialValue)}>
              {currencySymbol}
              {formatNumberToShort(totalImpact)}
            </div>
            <span className={classes.totalNumberDescription}>{t('Total Social Value')}</span>
          </div>
          <div>
            <div className={classes.totalNumber}>
              {currencySymbol}
              {formatNumberToShort(totalInvestment)}
            </div>
            <span className={classes.totalNumberDescription}>{t('Total Investment')}</span>
          </div>
        </div>
      </PageSection>
    </div>
  )
}

export default TotalInfo
